import React from 'react';
//import css from './css.module.less';
import { get } from 'lodash';
import { Form } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { DiscountValueType } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/AtDiscountValue';
import _Summary from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/Summary';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { EFrequencyUnit } from '../Frequency';
const Item = Form.Item;

const getFrequencyI18nKey = (frequencyUnit) => {
  const i18nKeyMapping = {
    [EFrequencyUnit.Days]: 'general.day(s)',
    [EFrequencyUnit.Weeks]: 'general.week(s)',
    [EFrequencyUnit.Months]: 'general.month(s)',
  };
  return i18nKeyMapping[frequencyUnit];
};

const Summary = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const generator = (discount, prefix?) => {
    const {
      enableGifts,
      fixAmount,
      gifts,
      percent,
      type,
      enableDirectDiscount,
    } = discount || {};

    const summaryContent = [];
    if (!enableGifts && !enableDirectDiscount) {
      summaryContent.push(
        `${
          prefix ||
          getI18n('salesChannelSubscriptionBuy.summary.frequencyApplied')
        }: ${getI18n('salesChannelSubscriptionBuy.summary.noGifts')}`,
      );
    }
    if (!enableGifts && enableDirectDiscount) {
      if (type === DiscountValueType.Percentage) {
        summaryContent.push(
          `${
            prefix ||
            getI18n('salesChannelSubscriptionBuy.summary.frequencyApplied')
          }: ${percent || 0}% ${getI18n(
            'salesChannelSubscriptionBuy.summary.offApplied',
          )}`,
        );
      }
      if (type === DiscountValueType.Reduction) {
        summaryContent.push(
          `${
            prefix ||
            getI18n('salesChannelSubscriptionBuy.summary.frequencyApplied')
          }: ${fixAmount || 0} ${getI18n(
            'salesChannelSubscriptionBuy.summary.reductionApplied',
          )}`,
        );
      }
    }
    if (enableGifts && !enableDirectDiscount) {
      summaryContent.push(
        `${
          prefix ||
          getI18n('salesChannelSubscriptionBuy.summary.frequencyApplied')
        }: ${replaceI18nVariables(
          getI18n('salesChannelSubscriptionBuy.summary.giftsforfirstorder'),
          (gifts || []).length,
        )}`,
      );
    }
    if (enableGifts && enableDirectDiscount) {
      if (type === DiscountValueType.Percentage) {
        summaryContent.push(
          `${
            prefix ||
            getI18n('salesChannelSubscriptionBuy.summary.frequencyApplied')
          }: ${percent || 0}% ${getI18n(
            'salesChannelSubscriptionBuy.summary.offApplied',
          )}; ${replaceI18nVariables(
            getI18n('salesChannelSubscriptionBuy.summary.giftsforfirstorder'),
            (gifts || []).length,
          )}`,
        );
      }
      if (type === DiscountValueType.Reduction) {
        summaryContent.push(
          `${
            prefix ||
            getI18n('salesChannelSubscriptionBuy.summary.frequencyApplied')
          }: ${fixAmount || 0} ${getI18n(
            'salesChannelSubscriptionBuy.summary.reductionApplied',
          )};  ${replaceI18nVariables(
            getI18n('salesChannelSubscriptionBuy.summary.giftsforfirstorder'),
            (gifts || []).length,
          )}`,
        );
      }
    }
    return summaryContent;
  };

  const { data, isPrimary } = props;
  const { status } = data;
  return (
    <SectionWrapper
      title={getI18n('general.summary')}
      style={{ paddingBottom: 32 }}>
      <Item shouldUpdate>
        {(f) => {
          const { getFieldValue } = f;
          const summaryContent = [];
          const name = isPrimary ? getFieldValue('name') : get(data, 'name');
          const applyToDifferentDiscount = isPrimary
            ? getFieldValue('applyToDifferentDiscount')
            : get(data, 'applyToDifferentDiscount');
          // console.log('applyToDifferentDiscount', applyToDifferentDiscount);
          const frequencies = isPrimary
            ? getFieldValue('frequencies')
            : get(data, 'frequencies');

          //console.log('ifrequencies', frequencies);
          const subscriptionBuyDiscount = isPrimary
            ? getFieldValue('subscriptionBuyDiscount')
            : get(data, 'subscriptionBuyDiscount');
          //if (isPrimary) {
          if (!applyToDifferentDiscount) {
            const _s = generator(subscriptionBuyDiscount);
            summaryContent.push(..._s);

            const fre = frequencies.map((i, index) => {
              const { frequency, frequencyUnit } = i;
              return `${getI18n(
                'salesChannelSubscriptionBuy.summary.frequency',
              )} ${index + 1} - ${getI18n(
                'salesChannelSubscriptionBuy.summary.every',
              )} ${frequency || 0} ${
                getI18n(getFrequencyI18nKey(frequencyUnit)) || ''
              }`;
            });
            summaryContent.push(...fre);
          } else {
            const fre = frequencies.map((i, index) => {
              const { frequency, frequencyUnit, discount } = i;
              const {
                enableGifts,
                fixAmount,
                gifts,
                percent,
                type,
                enableDirectDiscount,
              } = discount;

              const prefix = `${getI18n(
                'salesChannelSubscriptionBuy.summary.frequency',
              )} ${index + 1} - ${getI18n(
                'salesChannelSubscriptionBuy.summary.every',
              )} ${frequency || 0} ${
                getI18n(getFrequencyI18nKey(frequencyUnit)) || ''
              }`;
              //console.log('prefix', prefix);
              const temp = [];
              if (!enableGifts && !enableDirectDiscount) {
                temp.push(
                  `${prefix}: ${getI18n(
                    'salesChannelSubscriptionBuy.summary.noGifts',
                  )}`,
                );
              }
              if (!enableGifts && enableDirectDiscount) {
                if (type === DiscountValueType.Percentage) {
                  temp.push(
                    `${prefix}: ${percent || 0}% ${getI18n(
                      'salesChannelSubscriptionBuy.summary.offApplied',
                    )}`,
                  );
                }
                if (type === DiscountValueType.Reduction) {
                  temp.push(
                    `${prefix}: ${fixAmount || 0} ${getI18n(
                      'salesChannelSubscriptionBuy.summary.reductionApplied',
                    )}`,
                  );
                }
              }
              if (enableGifts && !enableDirectDiscount) {
                //console.log('item', i);
                temp.push(
                  `${prefix}: ${replaceI18nVariables(
                    getI18n(
                      'salesChannelSubscriptionBuy.summary.giftsforfirstorder',
                    ),
                    (gifts || []).length,
                  )}`,
                );
              }

              if (enableGifts && enableDirectDiscount) {
                if (type === DiscountValueType.Percentage) {
                  temp.push(
                    `${prefix}: ${percent || 0}% ${getI18n(
                      'salesChannelSubscriptionBuy.summary.offApplied',
                    )}; ${replaceI18nVariables(
                      getI18n(
                        'salesChannelSubscriptionBuy.summary.giftsforfirstorder',
                      ),
                      (gifts || []).length,
                    )}`,
                  );
                }
                if (type === DiscountValueType.Reduction) {
                  temp.push(
                    `${prefix}: ${fixAmount || 0} ${getI18n(
                      'salesChannelSubscriptionBuy.summary.reductionApplied',
                    )};  ${replaceI18nVariables(
                      getI18n(
                        'salesChannelSubscriptionBuy.summary.giftsforfirstorder',
                      ),
                      (gifts || []).length,
                    )}`,
                  );
                }
              }
              //   console.log('temp', temp);
              return temp;
            });
            // console.log('fre', fre);
            const s = [getI18n('salesChannelSubscriptionBuy.summary.eachSub')];

            summaryContent.push(...s, ...fre);
          }
          // }
          //console.log('summaryContent', summaryContent);

          return (
            <_Summary
              status={status}
              name={name}
              summaryContent={summaryContent || []}
            />
          );
        }}
      </Item>
    </SectionWrapper>
  );
};
export default Summary;
